import React from 'react';
import _get from 'lodash/get';
import _classNames from 'classnames';
import { Button, makeStyles } from '@material-ui/core';
import ArrowWhiteIcon from './images/ArrowUpRightWhiteIcon.svg';
import VisitSiteIcon from './images/visit.svg';
import { toSentenceCase } from '../../utils/stringUtils';

const useStyles = makeStyles(theme => ({
  root: ({ componentOverrides }) => ({
    borderRadius: 8,
    padding: '7px',
    ...theme.typography.pxSmall,
    textTransform: 'none',
    lineHeight: '18px',
    '& img, svg ': {
      marginLeft: 5,
    },
    ..._get(componentOverrides, 'VisitSiteButton', {}),
  }),
}));

export const VisitSiteButton = ({
  className,
  siteCopy,
  onClick,
  clientDetails,
  title,
  componentOverrides,
}) => {
  const classes = useStyles({ componentOverrides });
  const label = _get(
    siteCopy,
    'pageCopy.hybridLinkCardVisitSite',
    'Visit Site',
  );
  const customLabel = _get(clientDetails, 'metadata.customLinkCTA');

  return (
    <Button
      variant="contained"
      className={_classNames(className, classes.root)}
      onClick={onClick}
      color="primary"
      aria-label={title}
    >
      {toSentenceCase(customLabel || label)}
      <img src={componentOverrides ? VisitSiteIcon : ArrowWhiteIcon} alt="" />
    </Button>
  );
};
